/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/terms.scss';
import { 
  FaShieldAlt, 
  FaFileContract, 
  FaUserCheck, 
  FaEnvelope,
  FaHandshake,
  FaUserFriends,
  FaMoneyBillAlt,
  FaExclamationTriangle,
  FaGavel,
  FaBalanceScale
} from 'react-icons/fa';

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <Nav />

      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero-content">
          <h1>Terms & Conditions</h1>
          <h6>
            <a href="/">Home</a> - Terms & Conditions
          </h6>
        </div>
      </section>

      {/* Main Content */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-wrapper">
            {/* Left Side - Navigation */}
            {/* <div className="terms-nav">
              <h3>Document Navigation</h3>
              <nav className="document-links">
                <a href="#terms" className="document-link active">
                  <FaFileContract /> Terms & Conditions
                </a>
                <a href="#privacy" className="document-link">
                  <FaShieldAlt /> Privacy Policy
                </a>
                <a href="#user-rights" className="document-link">
                  <FaUserCheck /> User Rights
                </a>
                <a href="#contact" className="document-link">
                  <FaEnvelope /> Contact
                </a>
              </nav>
              
              <div className="legal-notice">
                <h4>Legal Notice</h4>
                <p>By using Artiza, you agree to all terms stated here.</p>
                <div className="compliance-badge">
                  <FaBalanceScale />
                  <span>Governing Law: Kenya</span>
                </div>
              </div>
            </div> */}

            {/* Right Side - Content */}
            <div className="terms-main">
              {/* Terms & Conditions Section */}
              <section id="terms" className="document-section">
                <div className="section-header">
                  <h2>Terms and Conditions</h2>
                  <p className="section-subtitle">
                    Effective Date: {new Date().toLocaleDateString()}
                  </p>
                  <p className="section-intro">
                    These Terms and Conditions govern your use of the Artiza Platform. Please read them carefully.
                  </p>
                </div>

                <div className="document-content">
                  {/* 11. Acceptance of Terms */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Acceptance of Terms</h3>
                    </div>
                    <p>
                      By accessing or using <strong>Artiza</strong>, you agree to be bound by these 
                      Terms and Conditions. If you do not agree, you must not use the Platform.
                    </p>
                    <div className="notice-box">
                      <FaExclamationTriangle />
                      <p><strong>Important:</strong> Your continued use of the Platform constitutes acceptance of these terms.</p>
                    </div>
                  </div>

                  {/* 12. Role of Artiza (Marketplace Disclaimer) */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Role of Artiza (Marketplace Disclaimer)</h3>
                    </div>
                    <p>
                      <strong>Artiza is a technology-enabled marketplace.</strong> Artiza does not provide 
                      construction, repair, fabrication, or professional services. All services are 
                      provided by independent artisans.
                    </p>
                    <div className="disclaimer-card">
                      <h4>Platform Role Disclaimer</h4>
                      <ul>
                        <li>Artiza connects clients with artisans</li>
                        <li>Artiza does not employ artisans</li>
                        <li>Artiza does not supervise work quality</li>
                        <li>Artiza is not a service provider</li>
                      </ul>
                    </div>
                  </div>

                  {/* 13. User Categories */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> User Categories</h3>
                    </div>
                    <p>Users of the Platform fall into the following categories:</p>
                    
                    <div className="user-categories">
                      <div className="category-card">
                        <div className="category-icon">
                          <FaUserFriends />
                        </div>
                        <h4>Clients</h4>
                        <p>Individuals or entities seeking services</p>
                        <ul className="category-details">
                          <li>Can post project requests</li>
                          <li>Can hire artisans</li>
                          <li>Can review and rate services</li>
                        </ul>
                      </div>

                      <div className="category-card">
                        <div className="category-icon">
                          <FaHandshake />
                        </div>
                        <h4>Artisans</h4>
                        <p>Independent service providers registered on the Platform</p>
                        <ul className="category-details">
                          <li>Can view and bid on projects</li>
                          <li>Provide services directly to clients</li>
                          <li>Set their own prices and terms</li>
                        </ul>
                      </div>
                    </div>
                    
                    <p className="note">
                      <strong>Note:</strong> Different obligations may apply depending on your user category.
                    </p>
                  </div>

                  {/* 14. Independent Contractor Relationship */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Independent Contractor Relationship</h3>
                    </div>
                    <p>
                      Artisans are <strong>independent contractors</strong> and not employees, agents, 
                      partners, or representatives of Artiza.
                    </p>
                    
                    <div className="relationship-details">
                      <div className="relationship-point">
                        <h4>No Employment</h4>
                        <p>Artiza does not employ artisans or provide benefits</p>
                      </div>
                      <div className="relationship-point">
                        <h4>No Supervision</h4>
                        <p>Artiza does not supervise, direct, or control work execution</p>
                      </div>
                      <div className="relationship-point">
                        <h4>No Liability</h4>
                        <p>Artiza is not liable for artisan actions or work quality</p>
                      </div>
                    </div>
                  </div>

                  {/* 15. Payments & Platform Fees */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Payments & Platform Fees</h3>
                    </div>
                    
                    <div className="payment-details">
                      <div className="payment-point">
                        <div className="payment-icon">
                          <FaMoneyBillAlt />
                        </div>
                        <div className="payment-text">
                          <h4>Payment Processing</h4>
                          <p>Payments are processed via approved third-party payment gateways</p>
                        </div>
                      </div>

                      <div className="payment-point">
                        <div className="payment-icon">
                          <FaMoneyBillAlt />
                        </div>
                        <div className="payment-text">
                          <h4>Payment Security</h4>
                          <p>Artiza may facilitate escrow-style or milestone-based payments for security</p>
                        </div>
                      </div>

                      <div className="payment-point">
                        <div className="payment-icon">
                          <FaMoneyBillAlt />
                        </div>
                        <div className="payment-text">
                          <h4>Platform Fees</h4>
                          <p>Platform service fees or commissions may be deducted from transactions</p>
                        </div>
                      </div>

                      <div className="payment-point">
                        <div className="payment-icon">
                          <FaMoneyBillAlt />
                        </div>
                        <div className="payment-text">
                          <h4>Pricing Disputes</h4>
                          <p>Artiza is not responsible for pricing disputes between users</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 16. Cancellations, Refunds & Disputes */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3>Cancellations, Refunds & Disputes</h3>
                    </div>
                    
                    <div className="dispute-details">
                      <div className="dispute-card">
                        <h4>Cancellations</h4>
                        <p>Cancellation and refund eligibility depends on:</p>
                        <ul>
                          <li>Service stage at time of cancellation</li>
                          <li>Artisan engagement level</li>
                          <li>Reason for cancellation</li>
                        </ul>
                      </div>

                      <div className="dispute-card">
                        <h4>Dispute Resolution</h4>
                        <p>Users are encouraged to resolve disputes directly</p>
                        <p className="small-note">
                          Artiza may assist with dispute facilitation but is not obligated to arbitrate
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 17. Reviews, Ratings & Content License */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3>Reviews, Ratings & Content License</h3>
                    </div>
                    
                    <div className="content-license">
                      <div className="license-point">
                        <h4>Content Ownership</h4>
                        <p>Users retain ownership of content they submit (reviews, ratings, photos)</p>
                      </div>
                      
                      <div className="license-point">
                        <h4>Platform License</h4>
                        <p>By submitting content, users grant Artiza a:</p>
                        <ul>
                          <li>Non-exclusive license</li>
                          <li>Royalty-free license</li>
                          <li>Worldwide license</li>
                        </ul>
                        <p>To use, display, reproduce, and distribute content for platform and marketing purposes.</p>
                      </div>
                    </div>
                  </div>

                  {/* 18. Prohibited Conduct */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Prohibited Conduct</h3>
                    </div>
                    
                    <p>Users must not engage in the following activities:</p>
                    
                    <div className="prohibited-conduct">
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Misrepresent identity or qualifications</span>
                      </div>
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Engage in fraud or illegal activity</span>
                      </div>
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Circumvent platform payments</span>
                      </div>
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Harass or abuse other users</span>
                      </div>
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Share false or misleading information</span>
                      </div>
                      <div className="prohibited-item">
                        <span className="prohibited-icon">❌</span>
                        <span className="prohibited-text">Violate intellectual property rights</span>
                      </div>
                    </div>
                  </div>

                  {/* 19. Account Suspension & Termination */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3>Account Suspension & Termination</h3>
                    </div>
                    
                    <p>
                      Artiza reserves the right to suspend or terminate accounts at its discretion for:
                    </p>
                    
                    <div className="termination-reasons">
                      <div className="reason">
                        <h4>Violations</h4>
                        <p>Violations of these Terms and Conditions</p>
                      </div>
                      <div className="reason">
                        <h4>Harmful Conduct</h4>
                        <p>Conduct that harms the Platform or other users</p>
                      </div>
                      <div className="reason">
                        <h4>Legal Compliance</h4>
                        <p>Requests from law enforcement or regulatory bodies</p>
                      </div>
                      <div className="reason">
                        <h4>Security</h4>
                        <p>Suspected fraudulent or malicious activity</p>
                      </div>
                    </div>
                  </div>

                  {/* 20. Limitation of Liability */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Limitation of Liability</h3>
                      <span className="article-number">Article 20</span>
                    </div>
                    
                    <div className="liability-notice">
                      <FaExclamationTriangle className="warning-icon" />
                      <p>
                        <strong>To the maximum extent permitted by law, Artiza shall not be liable for:</strong>
                      </p>
                      <ul>
                        <li>Indirect damages arising from services provided by artisans</li>
                        <li>Incidental damages from Platform use</li>
                        <li>Consequential damages from Platform use</li>
                        <li>Lost profits or business interruption</li>
                      </ul>
                    </div>
                  </div>

                  {/* 21. Indemnity */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3>Indemnity</h3>
                      <span className="article-number">Article 21</span>
                    </div>
                    
                    <div className="indemnity-clause">
                      <p>
                        Users agree to <strong>indemnify and hold Artiza harmless</strong> from claims arising out of:
                      </p>
                      <ul>
                        <li>Their use of the Platform</li>
                        <li>Breach of these Terms</li>
                        <li>Violation of any laws or regulations</li>
                        <li>Infringement of third-party rights</li>
                      </ul>
                    </div>
                  </div>

                  {/* 22. Governing Law */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Governing Law</h3>
                      <span className="article-number">Article 22</span>
                    </div>
                    
                    <div className="governing-law-card">
                      <FaGavel className="law-icon" />
                      <div className="law-content">
                        <h4>Jurisdiction</h4>
                        <p>These Terms and Conditions are governed by the laws of the Republic of Kenya.</p>
                        <p className="jurisdiction-note">
                          Any disputes shall be subject to the exclusive jurisdiction of Kenyan courts.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 23. Updates to These Documents */}
                  <div className="document-article">
                    <div className="article-header">
                      <h3> Updates to These Documents</h3>
                      <span className="article-number">Article 23</span>
                    </div>
                    
                    <div className="updates-policy">
                      <p>
                        Artiza may update these policies from time to time to reflect:
                      </p>
                      <ul>
                        <li>Changes in the law</li>
                        <li>Platform improvements</li>
                        <li>User feedback</li>
                        <li>Business needs</li>
                      </ul>
                      
                      <div className="updates-notice">
                        <FaExclamationTriangle />
                        <p>
                          <strong>Continued use of the Platform constitutes acceptance of the revised terms.</strong>
                        </p>
                      </div>
                      
                      <p className="notification-note">
                        Users will be notified of significant changes via email or Platform notification.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Contact Section */}
              <section id="contact" className="contact-section">
                <div className="section-header">
                  <h2>Contact Information</h2>
                </div>
                
                <div className="contact-details">
                  <div className="contact-method">
                    <h4>Legal & Support Contact</h4>
                    <div className="contact-info">
                      <FaEnvelope />
                      <a href="mailto:support@artiza.co.ke">support@artiza.co.ke</a>
                    </div>
                    <p className="response-time">
                      Response time: Within 24-48 hours
                    </p>
                  </div>
                  
                  <div className="contact-actions">
                    <a href="/contact" className="contact-button">
                      Go to Contact Page
                    </a>
                    <a href="mailto:support@artiza.co.ke" className="contact-button secondary">
                      Send Email
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;